export const themeConfig = {
  themeColor: "slate",
  direction: "ltr",
  mode: "light",
  locale: "en",
  primaryColorLevel: 600,
  cardBordered: false,
  panelExpand: false,
  controlSize: "md",
  navMode: "light",
  layout: {
    type: "modern",
    sideNavCollapse: false,
  },
};
